




















































































import Vue, { PropType } from "vue";
import StoreEditor from "@/stores/pages/StoreEditor.vue";
import { storeService } from "@/common/services/StoreService";
import { AdminStore } from "@/common/models/AdminStore";
import { StoreEditorPage } from "@/stores/pages/enums/StoreEditorPage";
import { StoreWorkstation } from "@/common/models/StoreWorkstation";
import { storeWorkstationService } from "@/common/services/StoreWorkstationService";
import WorkstationEdit from "@/stores/pages/components/WorkstationEdit.vue";

export default Vue.extend({
  name: "StoreInfo",
  components: {
    StoreEditor,
    WorkstationEdit,
  },
  props: {
    store: {
      type: Object as PropType<AdminStore>,
      required: true,
    },
  },
  data() {
    return {
      StoreEditorPage: StoreEditorPage,
      editOptions: [
        {
          text: this.$t("modules.stores.components.store-info.edit-store-info"),
          value: StoreEditorPage.BASIC_INFO,
        },
        {
          text: this.$t("modules.stores.components.store-info.edit-payment-configuration"),
          value: StoreEditorPage.PAYMENT_CONFIGURATION,
        },
        {
          text: this.$t("modules.stores.components.store-info.edit-pos-configuration"),
          value: StoreEditorPage.POS_CONFIGURATION,
        },
        {
          text: this.$t("modules.stores.components.store-info.edit-ordering-options"),
          value: StoreEditorPage.ORDERING_OPTIONS,
        },
      ],
      initProductLoading: false,
      fetchWorkstationLoading: false,
      storeWorkstations: [] as StoreWorkstation[],
      workstationDialog: false as boolean,
    };
  },
  methods: {
    storeUpdated(): void {
      this.$emit("updated");
    },
    async initializeStoreProducts(store: AdminStore): Promise<void> {
      this.initProductLoading = true;
      await storeService.initializeStoreProducts(store);
      this.initProductLoading = false;
    },
    async fetchWorkstations() {
      this.fetchWorkstationLoading = true;
      this.storeWorkstations = await storeWorkstationService.getWorkstations(this.store.id);
      this.fetchWorkstationLoading = false;
    },
  },
});
